var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":_vm.viewBox,"preserveAspectRatio":"xMinYMin meet"},domProps:{"innerHTML":_vm._s(_vm.paths)}})}
var staticRenderFns = []

export { render, staticRenderFns }